<div class="container page-content">
  <div class="tab-wrapper container">
    <!-- Nav tabs -->
    <mat-tab-group
      class="nav nav-tabs"
      [selectedIndex]="selectedIndex"
      (selectedTabChange)="onTabChange($event)"
      dynamicHeight
      animationDuration="0ms"
    >
      <mat-tab label="GENERATE EXCEL" #tab (click)="previousStep()">
        <div class="mat-elevation-z4">
          <div
            id="uploadfile"
            class="container example-container tab-pane active mb-5"
          >
            <br />
            <div class="row">
              <div class="col-sm-5">
                <label for="download">
                  Generate template based on the SKU added in the cart :</label
                >
              </div>
              <div class="col-sm-7">
                <button
                  class="btn btn-primary"
                  (click)="generateExcel()"
                  type="button"
                  mat-raised-button
                  extended
                  appearance="outline"
                >
                  <mat-icon>arrow_upward</mat-icon>
                  Generate Template
                </button>
              </div>
            </div>
            <!-- <div class=" mb-5 mt-1" style="float:right; ">
              <button mat-raised-button type="button" (click)="nextStep()" class="btn btn-primary">Next </button>
            </div> -->
          </div>
        </div>
      </mat-tab>
      <mat-tab label="UPLOAD EXCEL" #tab1 (click)="nextStep()">
        <div class="example-large-box mat-elevation-z4">
          <div id="uploadimage" class="container tab-pane active mb-5">
            <br />
            <div class="row mb-3 mt-3">
              @if (uploadProductFile == "") {
                <div class="col-sm-12">
                  <form class="form choose-file">
                    <label class="form__container" id="upload-container"
                      >Choose a file or Drag it here.
                      <input
                        class="form__file"
                        id="upload-files"
                        (change)="onFilesSelected($event)"
                        type="file"
                      />
                    </label>
                    <div id="files-list-container"></div>
                  </form>
                </div>
              } @else {
                <section class="mb-4">
                  <div style="float: right">
                    <a
                      href="javascript:void()"
                      style="color: black !important"
                      (click)="deleteUploadedExcel()"
                    >
                      <i
                        matTooltip="Delete"
                        matTooltipPosition="after"
                        class="material-icons"
                        >delete</i
                      ></a
                    >
                  </div>
                  <div>
                    <span style="font-weight: 500; font-size: small"
                      ><i class="fa fa-file-excel-o"></i>
                      {{ uploadProductFile }}</span
                    >
                    <span style="font-weight: bold; padding-left: 5px"
                      >{{ productFileSize | fileSize }}
                    </span>
                  </div>
                  <div>
                    <mat-progress-bar
                      [mode]="mode"
                      [value]="value"
                      color="accent"
                      [bufferValue]="bufferValue"
                    >
                    </mat-progress-bar>
                  </div>
                </section>
              }
              @if (downloadSuccessError) {
                <div class="row mb-4">
                  <div class="col-sm-8">
                    <label for="download" style="color: red">
                      Order files must be reviwed before order placed :</label
                    >
                  </div>
                  <div class="col-sm-4">
                    <button
                      class="btn btn-primary"
                      (click)="downloadOrderReviewFile()"
                      type="button"
                      mat-raised-button
                      extended
                      appearance="outline"
                    >
                      <mat-icon>arrow_upward</mat-icon>
                      Download
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-5" style="text-align: right">
                    <label for="PoNumber" style="padding-top: 20px">
                      PO Number :</label
                    >
                  </div>
                  <div class="col-sm-7">
                    <form [formGroup]="form">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <!-- <mat-label class="form-label" for="poNumber">PO Number</mat-label> -->
                        <input
                          matInput
                          formControlName="poNumber"
                          #poNumber
                          class="form-control"
                          placeholder="Please enter PO Number"
                        />
                      </mat-form-field>
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-5" style="text-align: right">
                    <label for="InvoiceEmail" style="padding-top: 20px">
                      Email address for invoice to be send to <span class="mandatory-star">*</span> :</label
                    >
                  </div>
                  <div class="col-sm-7">
                    <form [formGroup]="form">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <input
                          matInput
                          formControlName="invoiceEmail"
                          placeholder="Please enter Invoice Email"
                          maxlength="60"
                          required
                        />
                        <mat-error *ngIf="form.get('invoiceEmail')?.invalid">
                          {{ getInvoiceEmailErrorMessage() }}
                        </mat-error>
                      </mat-form-field>
                    </form>
                  </div>
                </div>
              }
            </div>

            <div class="d-flex justify-content-end mb-5 mt-4">
              <!-- <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right:5px;"
                (click)="previousStep()"> Previous</button> -->
              <button
                mat-raised-button
                type="button"
                (click)="cancelOrder()"
                class="btn btn-secondary"
              >
                Cancel Order
              </button>
              <button
                mat-raised-button
                [disabled]="uploadProductFile == ''"
                type="button"
                (click)="reviewOrder()"
                class="btn btn-secondary"
              >
                Validate Order
              </button>
              <button
                mat-raised-button
                [disabled]="downloadSuccessError == false || form.get('invoiceEmail')?.invalid"
                type="button"
                (click)="openConfirmationBox()"
                class="btn btn-primary"
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
